class Tooltip {
    constructor() {
        this.initialize();
    }

    initialize() {
        console.log('Tooltip initialize');

        $(document).on('mouseenter', '.item__tooltip', function() {
            $('.item__tooltip-prompt-text').addClass('showed');
        });

        $(document).on('click', '.item__tooltip .prompt-close', function() {
            $('.item__tooltip-prompt-text').removeClass('showed');
        });
    }
}

new Tooltip();

export { Tooltip };